import { createFileRoute, Outlet } from '@tanstack/react-router'
import { Layout } from '@/components/layout'

export const Route = createFileRoute('/dashboard')({
  component: DashboardLayout,
})

function DashboardLayout() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  )
}
